(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!window.customElements.get('yg-featured-product')) {
    class YGFeaturedProduct extends HTMLElement {
      connectedCallback() {
        this.handleClick = this.handleClick.bind(this);
        this.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
      }

      handleClick(event) {
        const mediaTab = event.target.closest('.yg-media-tab');
        if (mediaTab && this.contains(mediaTab)) {
          this.setActiveGallery(mediaTab.dataset.galleryType);
          return;
        }

        const galleryControl = event.target.closest('.yg-left-button, .yg-right-button');
        if (galleryControl && this.contains(galleryControl)) {
          const carousel = galleryControl.closest('.product-gallery')?.querySelector('media-carousel');
          if (!carousel) return;

          if (galleryControl.classList.contains('yg-left-button')) {
            if (typeof carousel.previous === 'function') {
              carousel.previous();
            } else {
              carousel.dispatchEvent(new CustomEvent('control:prev', { bubbles: true }));
            }
          } else if (typeof carousel.next === 'function') {
            carousel.next();
          } else {
            carousel.dispatchEvent(new CustomEvent('control:next', { bubbles: true }));
          }
          return;
        }

        const variantLabel = event.target.closest('[data-label]');
        if (variantLabel && this.contains(variantLabel)) {
          this.updateVariantMedia(variantLabel.dataset.label);
        }
      }

      setActiveGallery(galleryType) {
        this.querySelectorAll('.yg-media-tab').forEach((tab) => {
          tab.classList.toggle('active', tab.dataset.galleryType === galleryType);
        });

        this.querySelectorAll('.yg-product-gallery').forEach((gallery) => {
          const isActive = gallery.classList.contains(galleryType);
          gallery.classList.toggle('active', isActive);

          if (!isActive) {
            gallery.querySelectorAll('video, model-viewer').forEach((media) => {
              if (typeof media.pause === 'function') media.pause();
            });
          }
        });
      }

      updateVariantMedia(selectedValue) {
        if (!selectedValue) return;

        this.querySelectorAll('.yg-product-gallery').forEach((gallery) => {
          const mediaItems = gallery.querySelectorAll('.product-gallery__media');
          let firstVisibleMedia;

          mediaItems.forEach((media) => {
            const mediaValue = media.dataset.mediaAlt;
            const isVisible = !mediaValue || mediaValue === selectedValue;
            media.classList.toggle('active', isVisible);
            if (!firstVisibleMedia && isVisible) firstVisibleMedia = media;
          });

          if (firstVisibleMedia) {
            const carousel = gallery.querySelector('media-carousel');
            if (carousel) {
              carousel.dispatchEvent(new CustomEvent('control:select', {
                bubbles: true,
                detail: { index: [...mediaItems].indexOf(firstVisibleMedia) }
              }));
            }
          }
        });
      }
    }

    window.customElements.define('yg-featured-product', YGFeaturedProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-accordion-video-01"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  class YGAccordionVideo01 extends YGUtils {
    constructor() {
      super();
      this.swiperInstance = null;
      this.isMobileMode = false;
      this.isInitializing = true; // 标记正在初始化
      this.handleResize = this.handleResize.bind(this);
      this.debouncedResize = this.debounce(this.handleResize.bind(this), 150);
      this.handleItemHover = this.handleItemHover.bind(this);
      this.currentActiveItem = null;
    }

    get items() {
      return this.querySelectorAll('.yg-accordion-item');
    }

    connectedCallback() {
      // 初始化时根据当前屏幕尺寸设置正确的模式和监听器
      this.handleResize();
      window.addEventListener('resize', this.debouncedResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.debouncedResize);
      this.destroySwiper();
      this.removeHoverListeners();
    }

    initSwiper() {
      if (this.swiperInstance) return;

      // 如果是 folding card 模式且在移动端，不初始化轮播
      if (this.classList.contains('yg-accordion-folding-card') && this.isMobileMode) {
        return;
      }

      const galleryContainer = this.querySelector('.yg-accordion-item-container');
      if (!galleryContainer) return;

      this.swiperInstance = new Swiper(galleryContainer, {
        spaceBetween: 16,
        slidesPerView: 1,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        autoHeight: true,
        pagination: {
          el: '.yg-accordion-pagination',
          clickable: true,
        },
        on: {
          slideChange: () => {
            // 暂停所有视频
            this.items.forEach((item) => {
              this.controlVideo(item, 'pause');
            });
            // 播放当前活动的slide的视频
            const activeSlide = galleryContainer.querySelector('.swiper-slide-active');
            if (activeSlide) {
              this.controlVideo(activeSlide, 'play');
            }
          }
        },
        breakpoints: {
          220: {
            slidesPerView: 1,
            spaceBetween: 16,
          },
        },
      });

      // 初始化时播放第一个活动的slide的视频
      setTimeout(() => {
        const activeSlide = galleryContainer.querySelector('.swiper-slide-active');
        if (activeSlide) {
          this.controlVideo(activeSlide, 'play');
        }
      }, 100);
    }

    destroySwiper() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    }

    handleResize() {
      const width = window.innerWidth;
      const shouldBeMobile = width < 700;
      const modeChanged = shouldBeMobile !== this.isMobileMode;

      // 更新当前模式
      this.isMobileMode = shouldBeMobile;

      if (modeChanged || this.isInitializing) {
        if (shouldBeMobile) {
          // 切换到移动端模式
          this.removeHoverListeners();
          this.clearActiveItems();
          // 延迟初始化轮播，确保DOM已准备好
          setTimeout(() => this.initSwiper(), 50);
        } else {
          // 切换到PC端模式
          this.destroySwiper();
          this.addHoverListeners();
          // 重新激活当前项目（如果有的话）
          if (this.currentActiveItem) {
            this.currentActiveItem.classList.add('active');
            this.controlVideo(this.currentActiveItem, 'play');
          }
        }
      }

      // 标记初始化完成
      this.isInitializing = false;
    }

    addHoverListeners() {
      this.items.forEach((item) => {
        item.removeEventListener('mouseenter', this.handleItemHover);
        item.addEventListener('mouseenter', this.handleItemHover);
        item.removeEventListener('mouseleave', this.handleItemHover);
        item.addEventListener('mouseleave', this.handleItemHover);
      });
    }

    removeHoverListeners() {
      this.items.forEach((item) => {
        item.removeEventListener('mouseenter', this.handleItemHover);
        item.removeEventListener('mouseleave', this.handleItemHover);
      });
    }

    clearActiveItems() {
      this.items.forEach((item) => item.classList.remove('active'));
      this.currentActiveItem = null;
    }

    controlVideo(item, action) {
      const videoElement = item.querySelector('yg-video');
      if (videoElement && videoElement.pauseVideo && videoElement.playVideo) {
        // 检查是否有实际的视频内容
        const hasVideoContent = videoElement.type === 'video' && videoElement.videoContainer;
        if (hasVideoContent || videoElement.template) {
          if (action === 'play') {
            videoElement.playVideo();
          } else if (action === 'pause') {
            videoElement.pauseVideo();
          }
        }
      }
    }

    handleItemHover(e) {
      const type = e.type;
      const target = e.currentTarget;

      if (type === 'mouseenter') {
        this.items.forEach((item) => {
          item.classList.remove('active');
          this.controlVideo(item, 'pause');
        });
        target.classList.add('active');
        this.controlVideo(target, 'play');
        this.currentActiveItem = target;
      } else if (type === 'mouseleave') {
        setTimeout(() => {
          const hoverItem = [...this.items].find((item) => item.matches(':hover'));
          if (!hoverItem && this.currentActiveItem) {
            this.currentActiveItem.classList.add('active');
            this.controlVideo(this.currentActiveItem, 'play');
          }
        }, 10);
      }
    }
  }

  if (!window.customElements.get('yg-accordion-video-01')) {
    window.customElements.define('yg-accordion-video-01', YGAccordionVideo01);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-event-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!window.customElements.get('yg-event-countdown')) {
    class YGEventCountdown extends HTMLElement {
      connectedCallback() {
        this.endDate = new Date(this.getAttribute('end-date'));
        this.$values = this.querySelectorAll('[data-countdown-value]');

        if (Number.isNaN(this.endDate.getTime())) {
          return;
        }

        this.updateCountdown();
        this.intervalId = window.setInterval(() => this.updateCountdown(), 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.intervalId);
      }

      updateCountdown() {
        const remainingSeconds = Math.max(0, Math.floor((this.endDate.getTime() - Date.now()) / 1000));
        const days = Math.floor(remainingSeconds / 86400);
        const hours = Math.floor((remainingSeconds % 86400) / 3600);
        const minutes = Math.floor((remainingSeconds % 3600) / 60);
        const seconds = remainingSeconds % 60;
        const values = { days, hours, minutes, seconds };

        this.$values.forEach(($value) => {
          $value.textContent = String(values[$value.dataset.countdownValue]).padStart(2, '0');
        });
      }
    }

    window.customElements.define('yg-event-countdown', YGEventCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-number-list-gather"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    class YGNumberListGatherContainer extends YGUtils {
      constructor() {
        super();
        this.currentIndex = 0;
        this.totalBlocks = 0;
      }

      connectedCallback() {
        const headerItems = this.querySelectorAll('.yg-container-header-item');
        this.totalBlocks = headerItems.length;

        if (this.totalBlocks <= 1) return;

        this.prevButtons = this.querySelectorAll('.yg-prev-button');
        this.nextButtons = this.querySelectorAll('.yg-next-button');

        this.prevButtons.forEach(btn => {
          btn.addEventListener('click', () => this.prev());
        });

        this.nextButtons.forEach(btn => {
          btn.addEventListener('click', () => this.next());
        });
      }

      prev() {
        if (this.currentIndex > 0) {
          this.currentIndex--;
          this.updateDisplay();
        }
      }

      next() {
        if (this.currentIndex < this.totalBlocks - 1) {
          this.currentIndex++;
          this.updateDisplay();
        }
      }

      updateDisplay() {
        // 更新 header items
        const headerItems = this.querySelectorAll('.yg-container-header-item');
        headerItems.forEach((item, index) => {
          if (index === this.currentIndex) {
            item.classList.add('active');
          } else {
            item.classList.remove('active');
          }
        });

        // 更新 number list items
        const numberListItems = this.querySelectorAll('.yg-number-list-items');
        numberListItems.forEach((item, index) => {
          if (index === this.currentIndex) {
            item.classList.add('active');
          } else {
            item.classList.remove('active');
          }
        });

        // 更新 main items
        const mainItems = this.querySelectorAll('.yg-number-list-gather-main-item');
        mainItems.forEach((item, index) => {
          if (index === this.currentIndex) {
            item.classList.add('active');
          } else {
            item.classList.remove('active');
          }
        });

        // 更新所有按钮的禁用状态
        if (this.prevButtons && this.prevButtons.length > 0) {
          this.prevButtons.forEach(btn => {
            if (this.currentIndex === 0) {
              btn.classList.add('disabled');
            } else {
              btn.classList.remove('disabled');
            }
          });
        }

        if (this.nextButtons && this.nextButtons.length > 0) {
          this.nextButtons.forEach(btn => {
            if (this.currentIndex === this.totalBlocks - 1) {
              btn.classList.add('disabled');
            } else {
              btn.classList.remove('disabled');
            }
          });
        }
      }
    }

    if (!window.customElements.get("yg-number-list-gather-container")) {
      window.customElements.define("yg-number-list-gather-container", YGNumberListGatherContainer);
    }

  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-share-card"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-timeline"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    class YGTimeline extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
        this.paginationClickHandler = null;
      }

      connectedCallback() {
        this.initSwiper();
      }

      initSwiper() {
        this.swiper = new Swiper(this.querySelector('.swiper'), {
          breakpoints: {
            200: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            1070: {
              slidesPerView: 1,
              spaceBetween: 12,
            },
          },
          pagination: {
            el: this.querySelector('.yg-swiper-pagination'),
            type: 'bullets',
            clickable: true,
            renderBullet: (index, className) => {
              const time =
                this.querySelector('.swiper').swiper?.slides[index]?.dataset.time || index + 1;
              return `<button type="button" class="${className} yg-timeline-bullet">${time}</button>`;
            },
          },
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          on: {
            init: (swiper) => {
              this.updateSlideWidth(swiper);
              this.handlePaginationScroll(swiper);
            },
            resize: (swiper) => {
              this.updateSlideWidth(swiper);
              this.handlePaginationScroll(swiper);
            },
            slideChange: (e) => {
              if (window.innerWidth >= 1070) {
                if(e.activeIndex ===e.slides.length - 2) {
                  
                  this.slidesElTransformValue = e.slidesEl.style.transform;
                  e.slidesEl.style.setProperty('--transform', this.slidesElTransformValue);
                }

                if(e.activeIndex >= e.slides.length - 1) {
                  e.slidesEl.classList.add('yg-slides-el-transform');
                  
                } else {
                  e.slidesEl.classList.remove('yg-slides-el-transform');
                }
              }
 
            },
          }
        });
      }

      handlePaginationScroll(swiper) {
        const pagination = this.querySelector('.yg-swiper-pagination');
        if (!pagination) return;

        if (this.paginationClickHandler) {
          pagination.removeEventListener('click', this.paginationClickHandler, true);
          this.paginationClickHandler = null;
        }

        if (window.innerWidth <= 1069) {
          this.paginationClickHandler = (e) => {
            const bullet = e.target.closest('.yg-swiper-pagination-bullet');
            if (bullet) {
              const containerRect = pagination.getBoundingClientRect();
              const bulletRect = bullet.getBoundingClientRect();
              const scrollLeft = pagination.scrollLeft;
              const targetScrollLeft = scrollLeft + bulletRect.left - containerRect.left - (containerRect.width / 2) + (bulletRect.width / 2);

              pagination.scrollTo({
                left: targetScrollLeft,
                behavior: 'smooth'
              });
            }
          };

          pagination.addEventListener('click', this.paginationClickHandler, true);
        }
      }

      updateSlideWidth(swiper) {
        setTimeout(() => {
          swiper.slides.forEach(slide => {
            const width = slide.style.width;
            slide.style.setProperty('--swiper-slide-width', width);
          });
        }, 0);
      }
    }
    if (!window.customElements.get('yg-timeline')) {
      window.customElements.define('yg-timeline', YGTimeline);
    }
  })

  } catch(e) { console.error(e); }
})();
})();
